module.exports = __webpack_public_path__ + "img/e_3_6_r.6b497428.png";